import { render, staticRenderFns } from "./wiki_more_dropdown.vue.js?vue&type=template&id=c3a54f08&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_more_dropdown.vue?vue&type=template&id=c3a54f08&vue3"
import script from "./wiki_more_dropdown.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_more_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_more_dropdown.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_more_dropdown.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports